<template>
    <Dialog :visible="dialogIsVisible" modal header="Cancelar reserva"
        @update:visible="$emit('update:dialogIsVisible', false)" :closable="!paymentDone">
        <div class="flex flex-col items-center gap-2">
            <p>Tem certeza que deseja cancelar a reserva?</p>
            <p v-if="isStaff">Se aplicável, o autor da reserva confirmada receberá os créditos para usar em outras reservas.</p>
            <p v-else>Se aplicável, você receberá créditos para que possa utilizar em outras reservas.</p>
            <div class="flex md:flex-row gap-4 mt-4">
                <Button label="Cancelar esta reserva" severity="danger" @click="sendRevokeReservationRequest()" />
                <Button label="Cancelar todas as reservas" severity="danger" outlined @click="sendRevokeReservationRequest(true)" />    
            </div>
        </div>
    </Dialog>
</template>
<script>
import { Button, Dialog } from 'primevue';

import reservationService from '@/services/reservationService.js';

export default {
    name: 'DialogAgendaRevoke',
    components: {
        Dialog,
        Button
    },
    props: {
        dialogIsVisible: Boolean,
        reservationId: Number,
    },
    emits: ['update:dialogIsVisible'],
    data(){
        return {
            isStaff: this.$store.state.accessLevel == 'admin' || this.$store.state.accessLevel == 'secretary',
            paymentDone: false,
        }
    },
    methods: {
        setCalendarTargetInStore(bookingIso, hqId) {
            // Save target date and HQ in store so calendar will reload after redirect
            try {
                if (bookingIso) {
                    const dateOnly = bookingIso.split('T')[0];
                    this.$store.dispatch('setCalendarTargetDate', { date: dateOnly });
                }
                if (hqId) {
                    this.$store.dispatch('setCalendarTargetHq', { hqId: hqId });
                }
            } catch (e) {
                console.warn('(setCalendarTargetInStore) failed to set calendar target in store', e);
            }
        },
        sendRevokeReservationRequest(cancelAll = false) {
            const redirectBase = this.isStaff  ? '/admin' : '/user';

            // First try to fetch reservation to extract its date so we can redirect to the right week
            reservationService.getReservation(this.reservationId)
                .then(reservationResp => {
                    const reservation = reservationResp.data.booking;
                    const bookingIso = reservation.dateTime || null; // expected ISO datetime from backend
                    const hqId = reservation.roomInformations?.headquarters?.id || null;

                    // Proceed to cancel
                    return reservationService.cancelReservation(this.reservationId, cancelAll)
                        .then(response => ({ response, bookingIso, hqId }));
                })
                .catch(fetchError => {
                    // If fetching fails, still attempt to cancel but we won't have booking date
                    console.warn('(sendRevokeReservationRequest) could not fetch reservation before cancel', fetchError);
                    return reservationService.cancelReservation(this.reservationId, cancelAll)
                        .then(response => ({ response, bookingIso: null, hqId: null }));
                })
                .then(({ response, bookingIso, hqId }) => {
                    const { credits } = response.data;
                    const creditWord = (credits === 1 ? "crédito" : "créditos");

                    let message = `Sua reserva foi cancelada com sucesso! Você obteve ${credits} ${creditWord} para sua conta.`;
                    if(this.isStaff) {
                        message = `A reserva foi cancelada com sucesso! O autor da reserva recebeu ${credits} ${creditWord}.`;
                    }

                    if (response.status === 200) {
                        this.sendToast("Sucesso", message, "success");

                        // Set calendar target date and HQ in store so the calendar reloads with the correct data
                        this.setCalendarTargetInStore(bookingIso, hqId);

                        // Close the dialog before redirecting
                        this.$emit('update:dialogIsVisible', false);

                        // Redirect: admins to admin, users to /user (calendar will read the store date)
                        this.$router.push(this.isStaff ? '/admin' : '/user');
                    }
                })
                .catch(error => {
                    this.$emit('update:dialogIsVisible', false);

                    const errorMessage = error.response?.data?.message || null;
                    if(errorMessage === "Não é possível revogar reservas que já ocorreram ou estão em andamento."){
                        return this.sendToast("Erro ao cancelar", "Esta reserva já ocorreu ou está em andamento, não é possível cancelá-la.", "error");
                    }
                    if(errorMessage.startsWith("Esta reserva não pode ser revogada")){
                        return this.sendToast("Erro ao cancelar", "Esta reserva não pode ser revogada, motivos prováveis são reservas já reembolsadas, canceladas ou concluídas.", "error");
                    }

                    console.error('(sendRevokeReservationRequest)', error);
                    this.sendToast("Erro ao cancelar", "Ocorreu um erro ao cancelar sua reserva, tente novamente ou contate o suporte.", "error");
                });
        }
    }
}
</script>

<style scoped></style>